import {BlockMath, InlineMath} from "react-katex";
import logGraph from '../../../../../assets/logGraph.png'
import Reference from "../../../../Helpers/Reference"

const LogisticRegressionGradientDescent = () => {
    return (
        <div className="max-w-4xl mx-auto px-4">
            <p className="tw-header">Logistic Regression Gradient Descent</p>
            <hr className="mt-2 mb-2"/>
            <p className="tw-subtitle">
                We have now gone through the maths behind Logistic Regression. And more specifically how to calculate
                the cost function, which is simply put the average of the loss functions per training example.
                Now we will go through how to use this function within gradient descent, so we can train our model.
                For a quick recap, we will be using the sigmoid function as part of the larger logistic regression
                approach,
                which will be shown below, alongside the cost function.
            </p>
            <br/>

            <p className="tw-subtitle ">
                The sigmoid function is defined as:
            </p>
            <BlockMath math="Sigmoid(x) = \frac{1}{1 + e^{-x}}"/>
            <hr className="mt-2 mb-2"/>
            <p className="tw-subtitle ">
                The loss function is defined as:
            </p>
            <BlockMath math="L(a, y) = -[y \cdot \log(a) + (1-y) \cdot \log(1-a)]"/>
            <p className="tw-subtitle ">
                The Cost function is defined as:
            </p>
            <BlockMath math="J(w, b) = \frac{1}{m} \sum_{i=1}^{m} L(a^{(i)}, y^{(i)})"/>

            <p className="tw-subtitle ">
                Below is an awfully ugly drawing of log graph, and an illustration as to why we use -log(a) instead of
                log(a), as the loss cannot be a negative value. Once again, keep in mind that the output of the sigmoid
                function is between 0 and 1.
            </p>
            <img src={logGraph}/>
            <p className="tw-subtitle ">Gradient descent will function the exact same way as our example in
                Linear Regression. We will make predictions, thereafter calculate the cost function, and update our
                weights and biases based on the cost output, then predict again, and continue that loop until we reach
                convergence.
            </p>

            <br/>

            <p className="tw-subtitle">
                Now we will want to compute the gradient for the cost function. The purpose of the gradient is to
                calculate at what what level we will be updating our weights and biases. The way we compute the gradient
                is by taking the partial derivative of the cost function with respect to our weights, and bias. And that
                will look as follows:
            </p>
            <BlockMath math="\frac{\delta J(w,b)}{\delta b} = (f_w,_b(x^{(i)}) - y^{(i)})"/>
            <BlockMath math="\frac{\delta J(w,b)}{\delta w_j} = (f_w,_b(x^{(i)}) - y^{(i)})x_j ^{(i)}"/>

            <br/>

            <p className="tw-subtitle">
                These functions will be used in the following way:
            </p>
            <br/>

            <p className="tw-subtitle">
                Repeat until convergence:
                <BlockMath math="b = b - \alpha \frac{\delta J(w,b)}{\delta b}"/>
                <BlockMath math="w = w_j - \alpha \frac{\delta J(w,b)}{\delta w_j}; for: j  = 1, ..., n"/>
            </p>

        </div>
    )
}

export default LogisticRegressionGradientDescent;